import { Button, Dropdown, Option } from '@fluentui/react-components'
import { useDemandCaretakers } from '../hooks/useDemandCaretakers'
import { apiErrorMessage } from '../lib/apiError'

interface Props {
  selected: string[]
  onChange: (selected: string[]) => void
  focusArea?: string
  includeDeleted?: boolean
}

export function CaretakerFilter({ selected, onChange, focusArea, includeDeleted }: Props) {
  const { data = [], isPending, error, refetch } = useDemandCaretakers(focusArea, includeDeleted)
  const options = [
    { value: 'none', label: 'No caretaker' },
    ...data.map((person) => ({ value: String(person.id), label: `${person.name} (${person.count})` })),
  ]
  for (const id of selected) {
    if (!options.some((option) => option.value === id)) {
      options.push({ value: id, label: `Caretaker #${id}` })
    }
  }
  return (
    <div>
      <Dropdown
        multiselect
        size="small"
        aria-label="Filter by caretaker"
        placeholder={isPending ? 'Loading caretakers...' : 'All caretakers'}
        selectedOptions={selected}
        value={selected.map((id) => options.find((option) => option.value === id)?.label).join(', ')}
        onOptionSelect={(_, data) => onChange(data.selectedOptions)}
      >
        {options.map((option) => (
          <Option key={option.value} value={option.value} text={option.label}>
            {option.label}
          </Option>
        ))}
      </Dropdown>
      {selected.length > 0 && (
        <Button size="small" appearance="subtle" onClick={() => onChange([])}>
          Clear caretaker filter
        </Button>
      )}
      {error && (
        <div role="alert">
          Could not load caretakers. {apiErrorMessage(error)}
          <Button size="small" onClick={() => void refetch()}>Retry caretakers</Button>
        </div>
      )}
    </div>
  )
}
